// SleeveGapChart.jsx — DAS-3307: line chart of each account's gap to its fair
// benchmark over time, under "Which part pulled which way" on Portfolio Status.
import React, { useEffect, useState } from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend, ReferenceLine,
} from 'recharts';
import api from '../functions/api';

const LINE_COLORS = ['#1890ff', '#c62828', '#2e7d32', '#f0a30a', '#8884d8'];

const SleeveGapChart = ({ labels }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api.get('/sleeve_history')
      .then((res) => {
        if (!cancelled) setRows(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => {
        if (!cancelled) setRows([]);
      });
    return () => { cancelled = true; };
  }, []);

  const byDate = {};
  rows.forEach((row) => {
    if (!row || !row.as_of_date) return;
    if (!byDate[row.as_of_date]) byDate[row.as_of_date] = { as_of_date: row.as_of_date };
    if (row.gap_pts != null) byDate[row.as_of_date][row.account] = row.gap_pts;
  });
  const chartData = Object.values(byDate).sort((a, b) => a.as_of_date.localeCompare(b.as_of_date));
  const accounts = Object.keys(labels || {});

  if (chartData.length < 2) {
    return (
      <div data-testid="sleeve-gap-chart">
        <span style={{ color: '#999', fontSize: 13 }}>
          Gap history: {chartData.length} day(s) stored so far — the chart appears from the second day
        </span>
      </div>
    );
  }

  return (
    <div data-testid="sleeve-gap-chart">
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={chartData}>
          <XAxis dataKey="as_of_date" />
          <YAxis unit=" pts" />
          <Tooltip />
          <Legend />
          <ReferenceLine y={0} stroke="#ccc" />
          {accounts.map((account, i) => (
            <Line
              key={account}
              type="monotone"
              dataKey={account}
              name={labels[account]}
              stroke={LINE_COLORS[i % LINE_COLORS.length]}
              dot={false}
              strokeWidth={2}
              connectNulls={false}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SleeveGapChart;
